import { render, staticRenderFns } from "./GuardarComoPresupuesto.vue?vue&type=template&id=6846067e&"
import script from "./GuardarComoPresupuesto.vue?vue&type=script&lang=js&"
export * from "./GuardarComoPresupuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports